// extracted by mini-css-extract-plugin
export default {"mapWrapper":"MapRenderer_mapWrapper__Unabd","searchInput":"MapRenderer_searchInput__nqmiE"};